require('./brokerMyInvestmentsStocksTable.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const Immutable = require('immutable');
const classnames = require('classnames');

const { taggingEventHandled } = require('utilities/taggingEventHandled');

const { BrokerMyInvestmentsProductsTable } = require('../brokerMyInvestmentsProductsTable/brokerMyInvestmentsProductsTable');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BrokerMyInvestmentsProductsStocks = props => {
    const { immStocks, type, showCompleteList, isContractSection } = props;
    const customTitleClass = classnames('broker-products-table__titles', {
        [`ok-table-cell--header-${type}`]: !!type
    });
    const productValueClass = classnames('broker-products-table__value', {
        [`ok-table-cell--value-${type}`]: !!type
    });

    return (
        <OKTable className="broker-products-table">
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-products-table__name"
                        width="24%"
                    >
                        <FormattedText value="broker-productName" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className={customTitleClass}
                        width="7%"
                    >
                        <FormattedText value="broker-productSharesStocks" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__average-price"
                        width="8%"
                    >
                        <FormattedText value="broker-productAveragePrice" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__capital"
                        width="9%"
                    >
                        <FormattedText value="broker-productInvestedCapital" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__ratio"
                        width="10%"
                    >
                        <FormattedText value="broker-productNATStocks" />
                        <OKTooltip
                            alternativeIcon={true}
                            content="broker-stocksQuoteInfoTooltip"
                            offset={[100, -10]}
                            onHover={() => taggingEventHandled(props.pageName, 'productTableTooltip')}
                        />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className={productValueClass}
                        width="10%"
                    >
                        <FormattedText value="broker-productSharesActualValue" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__earnings"
                        width="14%"
                    >
                        <FormattedText value="broker-productEarnings" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-products-table__in-wallet"
                        width="9%"
                    >
                        <FormattedText value="broker-productInWallet" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        className="broker-products-table__actions"
                        width="9%"
                    />
                </OKTableRow>
            </thead>
            <BrokerMyInvestmentsProductsTable
                type={type}
                immStocks={immStocks}
                showCompleteList={showCompleteList}
                isContractSection={isContractSection}
                onHandleBuyClick={props.onHandleBuyClick}
                pageName={props.pageName}
            />
        </OKTable>
    );
};

BrokerMyInvestmentsProductsStocks.propTypes = {
    immStocks: PropTypes.object,
    type: PropTypes.string,
    showCompleteList: PropTypes.bool,
    isContractSection: PropTypes.bool,
    alternativeValueColumnTitle: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    pageName: PropTypes.string
};

BrokerMyInvestmentsProductsStocks.defaultProps = {
    immStocks: Immutable.List(),
    showCompleteList: false,
    alternativeValueColumnTitle: false
};

module.exports = BrokerMyInvestmentsProductsStocks;
